import React from 'react';
import { OKR_STATUS_META } from '../../utils/okrStatusUtils';
import './StatusFilterChips.css';

export default function StatusFilterChips({ selectedStatuses = [], onToggleStatus }) {
  const statuses = Object.keys(OKR_STATUS_META);
  
  return (
    <div className="m3-status-filter-chips">
      {statuses.map(status => {
        const meta = OKR_STATUS_META[status];
        const isSelected = selectedStatuses.includes(status);
        
        return (
          <button
            key={status}
            className={`m3-filter-chip ${isSelected ? 'selected' : ''}`}
            onClick={() => onToggleStatus && onToggleStatus(status)}
            style={{
              background: isSelected ? meta.bg : 'transparent',
              borderColor: meta.border || meta.color,
              color: isSelected ? meta.color : meta.color
            }}
            title={meta.tooltip || status}
          >
            <span className="m3-filter-chip-icon">{meta.icon || '●'}</span>
            <span className="m3-filter-chip-label">{status}</span>
          </button>
        );
      })}
    </div>
  );
}

